// extracted by css-extract-rspack-plugin
var _1 = "GLsLm";
var _2 = "AGceM";
var _3 = "AAXzM";
export { _1 as "brandIcon", _2 as "microsoft365UpsellBadge", _3 as "microsoft365UpsellIcon" }
